// extracted by mini-css-extract-plugin
export default {"video-container":"CustomVideo_video-container__YCMjh","video-controls":"CustomVideo_video-controls__wqvit"};